import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const themes = {
  dark: {
    pageBg: "#060d0d",
    cardBg: "#0d1f1f",
    cardBorder: "#2a4a4a",
    inputBg: "#162424",
    inputBorder: "#1e3333",
    divider: "#1e3333",
    textPrimary: "#e8f5f5",
    textSecondary: "#5a8a8a",
    textMuted: "#8ab0b0",
    cardShadow: "0 2px 12px rgba(0,0,0,0.5)",
  },
  light: {
  pageBg: "#eef4f4",
  cardBg: "#ffffff",
  cardBorder: "#c8dede",
  inputBg: "#f5fafa",
  inputBorder: "#c0d8d8",
  divider: "#ddeaea",
  textPrimary: "#0a1f1f",
  textSecondary: "#3a6060",
  textMuted: "#5a8080",
  cardShadow: "0 2px 8px rgba(0,0,0,0.10)",
},
};

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(
    () => localStorage.getItem("martsense_theme") || "dark"
  );

  const toggleTheme = () => {
    const next = mode === "dark" ? "light" : "dark";
    setMode(next);
    localStorage.setItem("martsense_theme", next);
  };

  const theme = themes[mode];

  useEffect(() => {
    document.body.style.background = theme.pageBg;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ mode, theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
